import React from "react";

import { connect } from "react-redux";

import ZeeTable from "components/ZeeTable";
import { has } from "lodash";

class CheckoutItem extends React.Component {
  state = {
    data: [],
  };

  columns = {
    quantity: { name: "Quantity" },
    supplier_id: {
      name: "Supplier",
      noEdit: true,
      canAdd: true,
      value: false,
      values: [
        { id: 0, name: "Please select" },
        ...this.currentSuppliers,
        { id: 0, name: "---" },
        ...this.otherSuppliers,
      ],
      format: (supplier_id, row) => {
        return this.props.supplier.find(
          (supplier) => parseInt(supplier.id) === supplier_id
        )?.name;
      },
    },
    partnumber: { name: "Part Number" },
    cost: { name: "Cost each" },
    total: { name: "Total", noEdit: true },
  };

  get classNames() {
    const classes = ["item"];

    return classes.join(" ");
  }

  get isVisible() {
    return this.props.isVisible;
  }

  get item() {
    return this.props.row ?? {};
  }

  get currentSuppliers() {
    const suppliers = this.props.stockSupplier
      .filter((stockSupplier) => stockSupplier.stock_id === this.item.id)
      .map((item) =>
        this.props.supplier.find((supplier) => supplier.id === item.supplier_id)
      );

    return suppliers;
  }

  get otherSuppliers() {
    const suppliers = this.props.supplier.reduce(
      (agg, item) =>
        this.currentSuppliers.find((supplier) => supplier.id === item.id)
          ? agg
          : [...agg, item],
      []
    );

    return suppliers;
  }

  get data() {
    return this.state.data ?? [];
  }

  parseRow(row) {
    const stockSupplier = this.props.stockSupplier
      .filter((stockSupplier) => stockSupplier.stock_id === this.item.id)
      .find((stockSupplier) => stockSupplier.supplier_id === row.supplier_id);

    const stockSupplierPrice = stockSupplier
      ? this.props.stockSupplierPrice
          .filter((item) => item.stock_supplier_id === stockSupplier.id)
          .sort((a, b) => (a.created > b.created ? -1 : 1))?.[0] ?? null
      : null;

    let isPartNumberBlank = !row.partnumber || row.partnumber === "";
    let isQuantityBlank =
      !row.quantity || row.quantity === "" || row.quantity < 0;
    let isCostBlank = !row.cost || row.cost === "" || row.cost < 0;

    const hasSupplier = Boolean(stockSupplier);
    const hasSupplierLatestPrice = Boolean(stockSupplierPrice);

    if (isQuantityBlank) {
      row.quantity = 0;
    }

    if (hasSupplier) {
      if (isPartNumberBlank) {
        row.partnumber = stockSupplier?.partnumber ?? "";
      }

      if (hasSupplierLatestPrice) {
        if (isCostBlank) {
          row.cost = (
            stockSupplierPrice?.price / stockSupplierPrice?.quantity
          ).toFixed(4);
        }
      }
    }
    row.total = (row.cost * row.quantity).toFixed(4);

    return { ...row };
  }

  onAdd(row) {
    row = this.parseRow(row);

    if (!row) {
      return false;
    }

    const { supplier_id } = row;

    if (!supplier_id || supplier_id === "0") {
      return false;
    }

    const data = [...this.data, row];

    this.setState({ data });

    return this.props.onRowsUpdate?.(data);
  }

  onEdit(row) {
    row = this.parseRow(row);

    if (!row) {
      return false;
    }

    const data = this.data.map((item) =>
      item.id === row.id ? { ...item, ...row } : item
    );

    this.setState({
      data,
    });

    return this.props.onRowsUpdate?.(data);
  }

  onDelete(row) {
    const data = this.data.reduce(
      (agg, item) => (item.id === row.id ? agg : [...agg, item]),
      []
    );

    this.setState({
      data,
    });

    return this.props.onRowsUpdate?.(data);
  }

  onToggle() {
    return this.props.onToggle();
  }

  render() {
    return (
      <tr className={this.classNames}>
        <td colspan="6">
          <ZeeTable
            columns={this.columns}
            data={this.data}
            orderBy="name"
            isEditing={true}
            hasEdit={true}
            hasAdd={true}
            hasDelete={true}
            onAdd={(row) => this.onAdd(row)}
            onEdit={(row) => this.onEdit(row)}
            onDelete={(row) => this.onDelete(row)}
          />
        </td>
      </tr>
    );
  }
}
export default connect((state) => {
  return {
    order: state.order.all,
    orderItem: state.order.item.all,
    product: state.product.all,
    productStock: state.product.stock.all,
    productGroup: state.product.group.all,
    stock: state.stock.all,
    stockSupplier: state.stock.supplier.all,
    stockSupplierPrice: state.stock.supplier.price.all,
    stockLedger: state.stock.ledger.all,
    supplier: state.supplier.all,
  };
})(CheckoutItem);
